import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col} from 'react-bootstrap'
import {infoStatus} from '../../core/redux/status'
import {linkFinder} from '../../core/links'
import DashboardPanel from '../../core/components/DashboardPanel'
import DashboardPanelAdd from '../../core/components/DashboardPanelAdd'
import DocumentDashboardPanel from '../../actradis/components/DocumentDashboardPanel'
import i18n from '../i18n'
import style from './ProviderDashboard.less'

class ProviderDashboard extends Component {
    static propTypes = {
    }

    render() {
        const {dispatch, provider, _appLinks} = this.props

        const panelHeader = (title) => (
            <h4>{title}</h4>
        )

        return (
            <div>
                <Row>
                    <Col sm={6} md={4}>
                        <DashboardPanel light
                            header={panelHeader(i18n.description)}>
                            <ul className={style.data}>
                                <li>
                                    <label>> {i18n.siret} :</label>
                                    <span> {provider.siretNumber}</span>
                                </li>
                            </ul>
                        </DashboardPanel>
                    </Col>
                    <Col sm={6} md={4}>
                        <DashboardPanelAdd 
                            onClick={() => dispatch(infoStatus(i18n.featureNotImplemented))} />
                    </Col>
                    {_appLinks.find(linkFinder('actradis/providercompanies')) && (
                        <Col sm={6} md={4}>
                            <DocumentDashboardPanel light
                                size='large' />
                        </Col>
                    )}
                </Row>
            </div>
        )
    }
}

ProviderDashboard = connect((state) => ({
    provider: state.provider.provider,
    _appLinks: state.app._links
}))(ProviderDashboard)

export default ProviderDashboard


// WEBPACK FOOTER //
// ./lib/provider/components/ProviderDashboard.js